import React, {ComponentType} from "react";
import {Button, DialogActions, DialogContent, DialogProps} from "@mui/material";
import {useTranslation} from "react-i18next";
import AlertDialog from "../alert-dialog";
import CustomDialogTitle from "../custom-dialog-title";

export type ConfirmationDialogProps = DialogProps & {
  onConfirm: () => void;
  onClose: () => void;
  title: string | ComponentType<any>;
  content: string | ComponentType<any>;
};
const ConfirmationDialog = ({open, onClose, onConfirm, title, content, ...dialogProps}: ConfirmationDialogProps) => {
  const {t} = useTranslation();
  return (
    <AlertDialog open={open} onClose={onClose} {...dialogProps}>
      <CustomDialogTitle onClose={onClose}>{title}</CustomDialogTitle>
      <DialogContent>{content}</DialogContent>
      <DialogActions>
        <Button id="confirmation-dialog__cancel-button" autoFocus onClick={onClose}>
          {t("commons.confirm.cancel")}
        </Button>
        <Button id="confirmation-dialog__confirm-button" onClick={onConfirm}>
          {t("commons.confirm.confirm")}
        </Button>
      </DialogActions>
    </AlertDialog>
  );
};

export default ConfirmationDialog;
